import type { FC, SVGAttributes } from 'react';
import { cloneElement, isValidElement } from 'react';
import { useTheme } from 'styled-components/macro';

export type IconPropsT = SVGAttributes<SVGElement> & {
  size?:
    | 'xs'
    | 'sm'
    | 'md'
    | 'lg'
    | 'xl'
    | '2xl'
    | '3xl'
    | '4xl'
    | '5xl'
    | '6xl'
    | '7xl'
    | '8xl'
    | '9xl'
    | '10xl'
    | '11xl'
    | '12xl'
    | '13xl';
  color?: 'white' | 'black' | 'darkBlue' | 'green' | 'grey' | 'brightGreen' | 'red' | 'gold';
};

const Icon: FC<IconPropsT> = ({ children, size, color, ...restSvgProps }) => {
  /**
   * Hooks
   */
  const theme = useTheme();

  /**
   * Variables
   */
  const svgSize = {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18,
    xl: 20,
    '2xl': 22,
    '3xl': 24,
    '4xl': 26,
    '5xl': 28,
    '6xl': 30,
    '7xl': 34,
    '8xl': 38,
    '9xl': 42,
    '10xl': 46,
    '11xl': 50,
    '12xl': 54,
    '13xl': 58,
  };
  const svgColor = {
    white: theme.colors.white,
    black: theme.colors.black,
    darkBlue: theme.colors.primary.variant1,
    green: theme.colors.secondary.variant2,
    brightGreen: theme.colors.secondary.variant1,
    grey: theme.colors.primary.variant8,
    red: theme.colors.highlight.variant5,
    gold: theme.colors.highlight.variant1,
  };

  return (
    <>
      {isValidElement(children) &&
        cloneElement(children, {
          ...restSvgProps,
          ...(size && { width: svgSize[size], height: svgSize[size] }),
          ...(color && { fill: svgColor[color] }),
        })}
    </>
  );
};

export default Icon;
